import { useReducer } from "react";

export const initial: State = {
	showSelectAppMenu: null,
	showAddNewAppDialog: false
};

export interface State {
	showSelectAppMenu: HTMLElement | null;
	showAddNewAppDialog: boolean;
}

enum ActionType {
	onChangeApp = "onChangeApp",
	showSelectAppMenu = "showSelectAppMenu",
	hideSelectAppMenu = "hideSelectAppMenu",
	showAddNewAppDialog = "showAddNewAppDialog",
	hideAddNewAppDialog = "hideAddNewAppDialog"
}

interface Action {
	type: string;
	val: string | HTMLElement;
}

function reducer(state: State, action: Action): State {
	switch (action.type) {
		case ActionType.showSelectAppMenu:
			return {
				...state,
				showSelectAppMenu: action.val as HTMLElement
			};
		case ActionType.hideSelectAppMenu:
			return {
				...state,
				showSelectAppMenu: null
			};
		case ActionType.showAddNewAppDialog:
			return {
				...state,
				showAddNewAppDialog: true
			};
		case ActionType.hideAddNewAppDialog:
			return {
				...state,
				showAddNewAppDialog: false
			};
		default:
			throw new Error();
	}
}

export default function useAppSectionActionsStore() {
	const [state, dispatch] = useReducer(reducer, initial);

	const actions = {
		showSelectAppMenu: (val: HTMLElement) => dispatch({ type: ActionType.showSelectAppMenu, val }),
		hideSelectAppMenu: () => dispatch({ type: ActionType.hideSelectAppMenu, val: "" }),
		showAddNewAppDialog: () => dispatch({ type: ActionType.showAddNewAppDialog, val: "" }),
		hideAddNewAppDialog: () => dispatch({ type: ActionType.hideAddNewAppDialog, val: "" })
	};

	return [state, actions] as const;
}
